import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const isElevatedRole = (r) => ["admin", "manager", "sales_manager"].includes(r);

export function RepPicker({ value, onChange, allLabel = "All reps", testid = "rep-picker" }) {
  const { user } = useAuth();
  const [reps, setReps] = useState([]);
  const elevated = isElevatedRole(user?.role);
  useEffect(() => {
    if (!elevated) return;
    api.get("/crm/reps").then(({ data }) => setReps(data.reps || [])).catch(() => {});
  }, [elevated]);
  if (!elevated) return null;
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
      className="px-3 py-2 border border-zinc-300 bg-white text-sm outline-none focus:ring-2 focus:ring-[#D4AF37]">
      <option value="all">{allLabel}</option>
      {user && <option value={user.id}>{`Me (${user.name})`}</option>}
      {reps.filter((r) => r.id !== user?.id).map((r) => <option key={r.id} value={r.id}>{r.name || r.email}</option>)}
    </select>
  );
}
